import api from '@/configs/GlobalRequestHandler.js';

export default {
  getUserMetrics: (params) => {
    return api.getRequest('/user/dashboard/metrics', { params });
  },

  // Métricas gerais
  getMetrics: (params) => {
    return api.getRequest('/admin/dashboard/metrics', { params });
  },
  
  // Gráficos
  getRevenueChart: (params) => {
    return api.getRequest('/admin/dashboard/revenue-chart', { params });
  },
  
  getUsersChart: (params) => {
    return api.getRequest('/admin/dashboard/users-chart', { params });
  },
  
  // Rankings e listas
  getTopUsers: (params) => {
    return api.getRequest('/admin/dashboard/top-users', { params });
  },
  
  getTopUsersByRevenue: (params) => {
    return api.getRequest('/admin/dashboard/top-users-revenue', { params });
  },
  
  getTopCampaigns: (params) => {
    return api.getRequest('/admin/dashboard/top-campaigns', { params });
  },
  
  getLatestCampaigns: (limit = 10, params = {}) => {
    return api.getRequest('/admin/dashboard/latest-campaigns', { 
      params: { ...params, limit } 
    });
  },
  
  getInactiveCampaigns: (params) => {
    return api.getRequest('/admin/dashboard/inactive-campaigns', { params });
  },

  getInactiveCampaignOwners: (params) => {
    return api.getRequest('/admin/dashboard/inactive-campaign-owners', { params });
  },

  getPlaqueEligible: (params) => {
    return api.getRequest('/admin/dashboard/plaque-eligible', { params });
  },

  getPaymentMethodsChart: (params) => {
    return api.getRequest('/admin/dashboard/payment-methods-chart', { params });
  },

  getCampaignDrawersChart: (params) => {
    return api.getRequest('/admin/dashboard/campaign-drawers-chart', { params });
  },

  getCampaignStatusChart: (params) => {
    return api.getRequest('/admin/dashboard/campaign-status-chart', { params });
  },

  getRecentActivity: (params) => {
    return api.getRequest('/admin/dashboard/recent-activity', { params });
  },

  getFinishedCampaigns: (params) => {
    return api.getRequest('/admin/dashboard/finished-campaigns', { params });
  },

  getLatestUsers: (params) => {
    return api.getRequest('/admin/dashboard/latest-users', { params });
  },

  getInactiveUsers: (params) => {
    return api.getRequest('/admin/dashboard/inactive-users', { params });
  },

  getSourcesAnalytics: (params) => {
    return api.getRequest('/admin/dashboard/sources-analytics', { params });
  },
};
